export default "__VITE_ASSET__DoIYgTKg__"